import { emailENUM, TipoFormaPagoEnumChoice } from '@/shared/constants';
import { PaymentMethodEnum } from '@/shared/interfaces';
import * as yup from 'yup';
import { validarRestriccionNumeroCelular, validateTelefono } from '..';


const itemSchema = yup.object().shape({
  coordenada: yup.string().required('La coordenada del punto enlace es obligatorio'),
  nombre: yup.string().required('El nombre del punto enlace es obligatorio'),
  estado: yup.boolean().required(),
  cobertura: yup.boolean().required('Cobertura obligatoria'),
  plan: yup.string().required('El plan del punto enlace es obligatorio'),
  direccion: yup.string().required('La dirección del punto enlace es obligatorio'),
});

////*Preventa

/* export const newPreventaPymesSchemaTem = yup.object({
  items: yup
    .array()
    .of(itemSchema)
    .min(1, 'Campos obligatorios para punto de enlace')
}); */

export const newPreventaPymesSchema = (customRestriccionCelular?:any) => yup.object({
  //direccion: yup.string().required('Campo Obligatorio'),
  items: yup
    .array()
    .of(itemSchema)
    .min(1, 'Debe agregar al menos un punto de enlace'),
  celular_2: (
      yup
        .string()
        .required('Este campo es obligatorio')
        .min(9, 'Número menor a 9 digitos')
        .test(
          'no-repetir',
          'Este número ya está siendo utilizado',
          function (value) {
            const otrosNumeros:any = [
              this.parent.celular,
              this.parent.celular_referencia,
              this.parent.telefono_fijo_referencia,
              this.parent.telefono_adicional,
            ].filter(Boolean);

            return !otrosNumeros.includes(value);
          }
        )
        .test(
          'validar-telefono',
          'El número ingresado no es permitido',
          function (value) {
            const result = validateTelefono(
              value,
              customRestriccionCelular
            );

            if (result instanceof yup.ValidationError) {
              return this.createError({
                message: result.message,
              });
            }

            return true;
          }
        )
    ),
  responsable_contable_celular: validarRestriccionNumeroCelular(
      yup
        .string()
        .required('Este campo es obligatorio')
        .min(10, 'Número menor a 10 dígitos')
        .test(
          'no-repetir',
          'Este número ya está siendo utilizado',
          function (value) {
            const otrosNumeros = [
              this.parent.celular,
              this.parent.celular_referencia,
              this.parent.telefono_fijo_referencia,
              this.parent.telefono_adicional,
              this.parent.celular_2
            ].filter(Boolean);

            return !otrosNumeros.includes(value);
          }
        ),
      customRestriccionCelular
  ),
  representante_celular1: validarRestriccionNumeroCelular(
      yup
        .string()
        .required('Este campo es obligatorio')
        .min(10, 'Número menor a 10 dígitos')
        .test(
          'no-repetir',
          'Este número ya está siendo utilizado',
          function (value) {
            const otrosNumeros:any = [
              this.parent.celular,
              this.parent.celular_referencia,
              this.parent.telefono_fijo_referencia,
              this.parent.telefono_adicional,
              this.parent.celular_2,
              this.parent.representante_celular2
            ].filter(Boolean);

            return !otrosNumeros.includes(value);
          }
        ),
      customRestriccionCelular
  ),
  representante_celular2: 
      yup
        .string()
        .required('Este campo es obligatorio')
        .test(
          'no-repetir',
          'Este número ya está siendo utilizado',
          function (value) {
            const otrosNumeros = [
              this.parent.celular,
              this.parent.celular_referencia,
              this.parent.telefono_fijo_referencia,
              this.parent.telefono_adicional,
              this.parent.representante_celular1
            ].filter(Boolean);

            return !otrosNumeros.includes(value);
          }
        )
        .test(
          'validar-telefono-1',
          'El número ingresado no es permitido',
          function (value) {
            const result = validateTelefono(
              value,
              customRestriccionCelular
            );

            if (result instanceof yup.ValidationError) {
              return this.createError({
                message: result.message,
              });
            }

            return true;
          }
        ),



  email_temporal: yup.string().required()
    .when('servicio_correo', {
      is: (e: string) => e == emailENUM.MANUALMENTE,
      then: schema =>
        schema.matches(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/, 'Ingresar un correo valido').typeError('Campo Obligatorio')
    }).when('servicio_correo', {
      is: (e: string) => e != emailENUM.MANUALMENTE,
      then: schema =>
        schema.required('El campo es obligatorio')
          .test('no-contains-banned-domains', 'Selecciona el dominio del correo en el campo "Servicio de Correo".', (value) => {
            const bannedDomains = ['gmail.com', 'outlook.com', 'hotmail.com', 'yahoo.com', 'icloud.com', 'protonmail.com', 'aol.com', 'zoho.com'];
            return !bannedDomains.some(domain => value?.includes(domain));
          }).typeError('Campo Obligatorio')
    }).typeError('Campo Obligatorio'),
  servicio_correo: yup.string().required('Campo Obligatorio'),
  tipo_contrato: yup.string().required('Campo Obligatorio'),
  //plan: yup.string().required('Campo Obligatorio'),
  //tipo_plan: yup.string().required('Campo Obligatorio'),
  //tipo_servicio: yup.string().required('Campo Obligatorio'),
  //velocidad: yup.string().required('Campo Obligatorio'),
  //valor_plan: yup.string().required('Campo Obligatorio'),
  //valor_instalacion: yup.string().required('Campo Obligatorio'),
  //valor_instalacion_iva: yup.string().required('Campo Obligatorio'),
  //valor_instalacion_total: yup.string().required('Campo Obligatorio'),
  //provincia: yup.string().required('Campo Obligatorio'),
  //ciudad: yup.string().required('Campo Obligatorio'),
  //zona: yup.string().required('Campo Obligatorio'),
  //sector: yup.string().required('Campo Obligatorio'),
  email_facturacion: yup
    .string()
    .required("El correo es obligatorio")
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/, "Correo inválido"),
  forma_pago: yup.string().required('Campo Obligatorio'),
  tipo_instalacion: yup.string().required('Campo Obligatorio'),
  numero_cuenta: yup
    .string()
    .when('codigo_forma_pago', {
      is: TipoFormaPagoEnumChoice.DEBITO,
      then: schema => schema.required('Campo Obligatorio'),
    })
    .optional(),

  tipo_cuenta_bancaria: yup
    .string()
    .when('codigo_forma_pago', {
      is: TipoFormaPagoEnumChoice.DEBITO,
      then: schema => schema.required('Campo Obligatorio'),
    })
    .optional(),

  tarjeta: yup
    .string()
    .when('codigo_forma_pago', {
      is: (formaPago: string) => formaPago === PaymentMethodEnum.TARJETA,
      then: schema => schema.required('Campo Obligatorio'),
    })
    .optional().nullable(),

  tarjeta_fecha_caducidad: yup
    .string()
    .when('codigo_forma_pago', {
      is: (formaPago: string) => formaPago === TipoFormaPagoEnumChoice.TARJETA,
      then: schema =>
        schema
          .required('Campo Obligatorio')
    })
    .optional().nullable(),

  numero_tarjeta: yup
    .string()
    .when('codigo_forma_pago', {
      is: (formaPago: string) => formaPago === TipoFormaPagoEnumChoice.TARJETA,
      then: schema =>
        schema
          .required('Campo Obligatorio')
          .max(24, 'La longitud máxima es 24 caracteres')
          .matches(/^[0-9]+$/, 'Ingresar una cuenta valida'),
    })
    .optional().nullable(),
  numero_cantidad_router_ac: yup.number().when('es_router_ac', {
    is: (v: boolean) => v,
    then: schema =>
      schema.required('Campo Obligatorio').min(1, 'El valor minimo es de 1').typeError('Campo Obligatorio')
  }).optional(),
  numero_cuotas_router_ac: yup.number().when('es_router_ac', {
    is: (v: boolean) => v,
    then: schema =>
      schema.required('Campo Obligatorio').min(1, 'El valor minimo es de 1').typeError('Campo Obligatorio')
  }).optional(),
  numero_cuotas_wifi_6: yup.number().when('requiere_wifi_6', {
    is: (v: boolean) => v,
    then: schema =>
      schema.required('Campo Obligatorio').min(1, 'El valor minimo es de 1').typeError('Campo Obligatorio')
  }).optional(),
  numero_cantidad_wifi_6: yup.number().when('requiere_wifi_6', {
    is: (v: boolean) => v,
    then: schema =>
      schema.required('Campo Obligatorio').min(1, 'El valor minimo es de 1').typeError('Campo Obligatorio')
  }).optional(),
  numero_cuotas_android_tv: yup.number().when('es_android_tv', {
    is: (v: boolean) => v,
    then: schema =>
      schema.required('Campo Obligatorio').min(1, 'El valor minimo es de 1').typeError('Campo Obligatorio')
  }).optional(),
  numero_cantidad_android_tv: yup.number().when('es_android_tv', {
    is: (v: boolean) => v,
    then: schema =>
      schema.required('Campo Obligatorio').min(1, 'El valor minimo es de 1').typeError('Campo Obligatorio')
  }).optional(),
  numero_cuotas_ups: yup.number().when('es_ups', {
    is: (v: boolean) => v,
    then: schema =>
      schema.required('Campo Obligatorio').min(1, 'El valor minimo es de 24').typeError('Campo Obligatorio')
  }).optional(),
  numero_cantidad_ups: yup.number().when('es_ups', {
    is: (v: boolean) => v,
    then: schema =>
      schema.required('Campo Obligatorio').min(1, 'El valor minimo es de 1').typeError('Campo Obligatorio')
  }).optional(),
  entidad_financiera: yup
    .string()
    .when('codigo_forma_pago', {
      is: (formaPago: string) => formaPago === TipoFormaPagoEnumChoice.TARJETA,
      then: schema =>
        schema
          .required('Campo Obligatorio')
    })
    .optional().nullable(),
  representante_legal_tipo_identificacion: yup.string().required('Campo es requerido'),
  representante_legal_identificacion: yup.string().required('Campo es requerido'),
  representante_legal_razon_social: yup.string().required('Campo es requerido'),
  direccion_facturacion: yup.string().required('Campo es requerido')
});
